(() => {
  if (window.lsstlkBeatsReady) return;
  window.lsstlkBeatsReady = true;
  const root = window.Shopify?.routes?.root || '/';
  const time = (s) => Number.isFinite(s) ? `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, '0')}` : '0:00';
  const audioOf = (e) => e.target instanceof HTMLAudioElement && e.target.matches('[data-lb-audio]') ? e.target : null;
  const catalogs = new WeakMap();
  const loadCatalog = (catalog) => {
    if (catalogs.has(catalog)) return catalogs.get(catalog);
    const pending = (async () => {
      const rows = [], visited = new Set();
      let next = new URL(location.href);
      next.searchParams.set('page', '1');
      while (next) {
        next.searchParams.set('section_id', catalog.dataset.sectionId);
        if (visited.has(next.href)) throw new Error('Pagination loop');
        visited.add(next.href);
        const response = await fetch(next.href, { headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Search unavailable');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const list = document.querySelector('[data-lb-page-list]');
        if (!list) throw new Error('Search unavailable');
        rows.push(...list.querySelectorAll('[data-lb-row]'));
        next = list.dataset.nextPage ? new URL(list.dataset.nextPage, location.origin) : null;
      }
      return rows;
    })();
    catalogs.set(catalog, pending);
    pending.catch(() => catalogs.delete(catalog));
    return pending;
  };
  const update = (audio) => {
    const player = audio.closest('[data-lb-player]');
    player?.querySelectorAll('[data-lb-play]').forEach((button) => {
      button.textContent = audio.paused ? '▶' : '❚❚';
      button.setAttribute('aria-label', audio.paused ? 'Play preview' : 'Pause preview');
      button.setAttribute('aria-pressed', String(!audio.paused));
    });
    const seek = player?.querySelector('[data-lb-seek]');
    if (seek) { seek.max = Number.isFinite(audio.duration) ? audio.duration : 0; seek.disabled = !Number.isFinite(audio.duration); if (!seek.matches(':active')) seek.value = audio.currentTime; }
    const current = player?.querySelector('[data-lb-current]'), duration = player?.querySelector('[data-lb-duration]');
    if (current) current.textContent = time(audio.currentTime);
    if (duration) duration.textContent = time(audio.duration);
  };
  document.addEventListener('click', async (event) => {
    const button = event.target.closest?.('.lb-shell [data-lb-play]'); if (!button) return;
    const player = button.closest('[data-lb-player]'), audio = player?.querySelector('[data-lb-audio]'); if (!audio) return;
    if (!audio.paused) { audio.pause(); return; }
    document.querySelectorAll('[data-lb-audio]').forEach((other) => { if (other !== audio) other.pause(); });
    try { await audio.play(); } catch (_) { const status = player.querySelector('[data-lb-status]'); if (status) status.textContent = 'Preview unavailable. Please try again.'; }
  });
  ['loadedmetadata','durationchange','timeupdate','pause','ended','play'].forEach((name) => document.addEventListener(name, (event) => {
    const audio = audioOf(event); if (!audio) return;
    if (name === 'play') document.querySelectorAll('[data-lb-audio]').forEach((other) => { if (other !== audio) other.pause(); });
    update(audio);
  }, true));
  document.addEventListener('error', (event) => {
    const audio = audioOf(event); if (!audio) return;
    const player = audio.closest('[data-lb-player]'), status = player?.querySelector('[data-lb-status]');
    if (status) status.textContent = 'Preview unavailable for this beat.';
    player?.querySelectorAll('[data-lb-play]').forEach((button) => { button.disabled = true; });
  }, true);
  document.addEventListener('input', async (event) => {
    const seek = event.target.closest?.('[data-lb-seek]'), audio = seek?.closest('[data-lb-player]')?.querySelector('[data-lb-audio]');
    if (audio && Number.isFinite(audio.duration)) audio.currentTime = Math.min(audio.duration, Math.max(0, Number(seek.value)));
    const input = event.target.closest?.('[data-lb-search]'); if (!input) return;
    const query = input.value.trim().toLowerCase(), catalog = input.closest('[data-lb-catalog]');
    if (!catalog) return;
    const status = catalog.querySelector('[data-lb-search-status]'), results = catalog.querySelector('[data-lb-search-results]');
    const page = catalog.querySelector('[data-lb-page-list]'), pagination = catalog.querySelector('[data-lb-pagination]');
    catalog.querySelectorAll('[data-lb-audio]').forEach((item) => item.pause());
    results.hidden = !query; page.hidden = Boolean(query); if (pagination) pagination.hidden = Boolean(query);
    results.replaceChildren(); status.textContent = query ? 'Searching all beats in this selection…' : '';
    if (!query) return;
    try {
      const rows = await loadCatalog(catalog);
      if (input.value.trim().toLowerCase() !== query || !catalog.isConnected) return;
      const matches = rows.filter((row) => row.querySelector('.lb-title').textContent.toLowerCase().includes(query) || row.querySelector('.lb-meta').textContent.toLowerCase().includes(query));
      results.replaceChildren(...matches.map((row) => row.cloneNode(true)));
      status.textContent = matches.length ? `${matches.length} matching ${matches.length === 1 ? 'beat' : 'beats'}.` : 'No beats match your search.';
    } catch (_) {
      if (input.value.trim().toLowerCase() !== query) return;
      status.textContent = 'Search is temporarily unavailable. Browse the pages below.';
      page.hidden = false; if (pagination) pagination.hidden = false;
    }
  });
  document.addEventListener('change', (event) => {
    const select = event.target.closest?.('.lb-shell select[name="id"]');
    const acceptance = select?.form?.querySelector('[data-lb-license-acceptance]');
    if (acceptance) acceptance.checked = false;
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest?.('.lb-shell [data-lb-add-form], .lb-shell .lb-product-form');
    if (!form) return;
    const status = form.querySelector('[data-lb-cart-status]');
    const acceptance = form.querySelector('[data-lb-license-acceptance]');
    if (!acceptance || !acceptance.checked) {
      event.preventDefault();
      if (status) status.textContent = 'Read and accept the selected license agreement before adding this beat.';
      acceptance?.focus();
      acceptance?.reportValidity();
      return;
    }
    if (!window.fetch) return;
    event.preventDefault(); if (form.dataset.busy) return;
    const button = form.querySelector('[type="submit"]'), data = new FormData(form);
    if (!data.get('id')) { if (status) status.textContent = 'Choose an available license.'; return; }
    const tier = form.querySelector('select[name="id"]')?.selectedOptions[0]?.dataset.lbLicenseTier;
    if (!tier) { if (status) status.textContent = 'Choose an available license.'; return; }
    data.set('properties[License acceptance]', acceptance.value);
    data.set('properties[License tier]', tier);
    data.set('properties[License accepted at UTC]', new Date().toISOString());
    form.dataset.busy = 'true'; if (button) button.disabled = true; if (status) status.textContent = 'Adding license…';
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    try {
      if (cart?.getSectionsToRender) { data.set('sections', cart.getSectionsToRender().map((section) => section.id).join(',')); data.set('sections_url', location.pathname); cart.setActiveElement?.(button); }
      const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'Unable to add this license.');
      try {
        if (cart?.renderContents && result.sections) { cart.classList.remove('is-empty'); cart.renderContents(result); }
        else {
          const response = await fetch(root + '?sections=cart-icon-bubble');
          if (response.ok) { const sections = await response.json(), bubble = document.getElementById('cart-icon-bubble'); const html = new DOMParser().parseFromString(sections['cart-icon-bubble'] || '', 'text/html'), content = html.querySelector('.shopify-section'); if (bubble && content) bubble.innerHTML = content.innerHTML; }
        }
      } catch (_) { /* The add succeeded; the visible cart link remains a reliable fallback. */ }
      if (status) status.textContent = 'License added to cart.';
    } catch (error) { if (status) status.textContent = error.message || 'Unable to add this license. Please try again.'; }
    finally { delete form.dataset.busy; if (button) button.disabled = false; }
  });
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-lb-audio]').forEach((audio) => audio.pause()));
})();
